import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { catalogImportTranslationRef } from '@backstage/plugin-catalog-import';

/**
 * Every Registrar existente text in pt-BR (Story 2.3, AC-18): the stock
 * steps 2–4 of the wizard, the step labels and the buttons. The app's step 1
 * and help panel read the app's own messages (`catalogImport.*`).
 */
export const catalogImportMessages = TranslationBlueprint.make({
  name: 'byx-catalog-import',
  params: {
    resource: createTranslationMessages({
      ref: catalogImportTranslationRef,
      messages: {
        'buttons.back': 'Voltar',
        'defaultImportPage.headerTitle': 'Registrar existente',
        'defaultImportPage.contentHeaderTitle':
          'Comece a acompanhar o seu componente no {{appTitle}}',
        'defaultImportPage.supportTitle':
          'Comece a acompanhar o seu componente no {{appTitle}} adicionando-o ao catálogo.',
        'importInfoCard.title': 'Como funciona',
        'importInfoCard.deepLinkTitle': 'Saiba mais sobre o catálogo',
        'importInfoCard.linkDescription':
          'Informe a URL do repositório do código para adicioná-lo ao {{appTitle}}.',
        'importInfoCard.fileLinkTitle': 'Link para um arquivo existente',
        'importInfoCard.examplePrefix': 'Exemplo: ',
        'importInfoCard.fileLinkDescription':
          'O assistente analisa o arquivo, mostra uma prévia das entidades e as adiciona ao catálogo do {{appTitle}}.',
        'importInfoCard.githubIntegration.title': 'Link para um repositório',
        'importInfoCard.githubIntegration.label': 'Só GitHub',
        'importInfoCard.exampleDescription':
          'O assistente encontra todos os arquivos {{catalogFilename}} do repositório, mostra uma prévia das entidades e as adiciona ao catálogo do {{appTitle}}.',
        'importInfoCard.preparePullRequestDescription':
          'Se nenhuma entidade for encontrada, o assistente prepara um pull request que adiciona um {{catalogFilename}} de exemplo; o catálogo do {{appTitle}} carrega as entidades assim que o pull request for aceito.',
        'importStepper.singleLocation.title': 'Selecionar localizações',
        'importStepper.singleLocation.description':
          'Localizações encontradas: 1',
        'importStepper.multipleLocations.title': 'Selecionar localizações',
        'importStepper.multipleLocations.description':
          'Localizações encontradas: {{length, number}}',
        'importStepper.noLocation.title': 'Criar pull request',
        'importStepper.noLocation.createPr.detailsTitle':
          'Detalhes do pull request',
        'importStepper.noLocation.createPr.titleLabel':
          'Título do pull request',
        'importStepper.noLocation.createPr.titlePlaceholder':
          'Adicionar os arquivos de descrição de entidades do catálogo',
        'importStepper.noLocation.createPr.bodyLabel':
          'Descrição do pull request',
        'importStepper.noLocation.createPr.bodyPlaceholder':
          'Um texto descritivo, com suporte a Markdown',
        'importStepper.noLocation.createPr.configurationTitle':
          'Configuração da entidade',
        'importStepper.noLocation.createPr.componentNameLabel':
          'Nome do componente criado',
        'importStepper.noLocation.createPr.componentNamePlaceholder':
          'meu-componente',
        'importStepper.noLocation.createPr.ownerLoadingText':
          'Carregando as squads…',
        'importStepper.noLocation.createPr.ownerHelperText':
          'Escolha um dono na lista ou informe a referência de uma squad ou de uma pessoa',
        'importStepper.noLocation.createPr.ownerErrorHelperText':
          'campo obrigatório',
        'importStepper.noLocation.createPr.ownerLabel': 'Dono',
        'importStepper.noLocation.createPr.ownerPlaceholder': 'minha-squad',
        'importStepper.noLocation.createPr.codeownersHelperText':
          'Atenção: isto falha se não houver um arquivo CODEOWNERS no repositório de destino.',
        'importStepper.analyze.title': 'Informar URL',
        'importStepper.prepare.title': 'Ações de importação',
        'importStepper.prepare.description': 'Opcional',
        'importStepper.review.title': 'Revisar',
        'importStepper.finish.title': 'Concluir',
        'stepFinishImportLocation.backButtonText': 'Registrar outro',
        'stepFinishImportLocation.repository.title':
          'Este pull request foi aberto: ',
        'stepFinishImportLocation.repository.description':
          'As suas entidades serão importadas assim que o pull request for aceito.',
        'stepFinishImportLocation.locations.new':
          'Estas entidades foram adicionadas ao catálogo:',
        'stepFinishImportLocation.locations.existing':
          'Uma atualização foi pedida para estas localizações:',
        'stepFinishImportLocation.locations.viewButtonText': 'Ver no catálogo',
        'stepFinishImportLocation.locations.backButtonText': 'Registrar outro',
        'stepInitAnalyzeUrl.error.repository':
          'Não foi possível gerar entidades para este repositório.',
        'stepInitAnalyzeUrl.error.locations':
          'Não há nenhuma entidade neste endereço.',
        'stepInitAnalyzeUrl.error.default':
          'A análise devolveu um resultado desconhecido ({{type}}). Fale com o time de plataforma.',
        'stepInitAnalyzeUrl.error.url':
          'A URL precisa começar com http:// ou https://.',
        'stepInitAnalyzeUrl.urlHelperText':
          'Endereço completo do catalog-info.yaml ou do repositório no GitHub',
        'stepInitAnalyzeUrl.nextButtonText': 'Analisar',
        'stepPrepareCreatePullRequest.description':
          'Você informou o link de um repositório {{integrationType}}, mas nenhum {{catalogFilename}} foi encontrado. Use este formulário para abrir um pull request que cria o arquivo.',
        'stepPrepareCreatePullRequest.previewPr.title':
          'Prévia do pull request',
        'stepPrepareCreatePullRequest.previewPr.subheader':
          'Criar um novo pull request',
        'stepPrepareCreatePullRequest.previewCatalogInfo.title':
          'Prévia das entidades',
        'stepPrepareCreatePullRequest.nextButtonText': 'Criar pull request',
        'stepPrepareSelectLocations.locations.description':
          'Selecione uma ou mais localizações do seu repositório git:',
        'stepPrepareSelectLocations.locations.selectAll': 'Selecionar todas',
        'stepPrepareSelectLocations.existingLocations.description':
          'Estas localizações já existem no catálogo:',
        'stepPrepareSelectLocations.nextButtonText': 'Revisar',
        'stepReviewLocation.prepareResult.title':
          'Este pull request foi aberto: ',
        'stepReviewLocation.prepareResult.description':
          'Você já pode importar a localização: o {{appTitle}} busca as entidades assim que o pull request for aceito.',
        'stepReviewLocation.catalog.exists':
          'Estas localizações já existem no catálogo:',
        'stepReviewLocation.catalog.new':
          'Estas entidades serão adicionadas ao catálogo:',
        'stepReviewLocation.refresh': 'Atualizar',
        'stepReviewLocation.import': 'Importar',
      },
    }),
  },
});
